<script setup lang="ts">
  import { inject } from 'vue';

  import { DESCRIPTION_LIST_INJECTION } from '../DescriptionList/DescriptionList.keys';

  const descriptionListInjectedValues = inject(DESCRIPTION_LIST_INJECTION.key);
  if (!descriptionListInjectedValues) {
    throw new Error('DescriptionListDetail must be used within a DescriptionList component.');
  }
  const { variant } = descriptionListInjectedValues;
</script>

<template>
  <dd
    class="stash-description-list-detail flex-1 text-ice-900"
    :class="{
      'md:text-right': variant === 'space-between',
    }"
    data-test="stash-description-list-detail"
    :data-variant="variant"
  >
    <!-- @slot Default slot, for rendering a description detail -->
    <slot></slot>
  </dd>
</template>
